import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import { Flip } from "gsap/Flip";
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
gsap.registerPlugin(Flip);
gsap.registerPlugin(useGSAP);

const root = ReactDOM.createRoot(document.getElementById("root"));

const batch = Flip.batch("test");

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
